import YklService from 'services/YklService';
import {extractApiErrors} from './api_errors';

const {yklAxios} = YklService;

export const getPlayerStats = (state) => {
    return yklAxios.post('/players/stats', state)
    .then(res => res.data)
    .catch(error => Promise.reject(extractApiErrors(error.response || {})));
}